import { Component } from '@angular/core';
import {Global} from "../global";

@Component({
  selector: 'page-footer',
  templateUrl: 'page-footer.component.html'
})
export class PageFooterComponent {

  constructor(public global: Global){}

  get copyright(): string {
    return this.global.copyright;
  }
}



// WEBPACK FOOTER //
// ./src/app/painel/page-footer.component.ts